import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/faq.png'


const _hoisted_1 = { class: "faq-area pb-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = {
  class: "col-lg-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "100"
}
const _hoisted_5 = { class: "accordion" }
const _hoisted_6 = { class: "accordion-header" }
const _hoisted_7 = ["aria-expanded", "onClick"]
const _hoisted_8 = { class: "accordion-collapse collapse show" }
const _hoisted_9 = { class: "accordion-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "faq-content" }, [
            _createElementVNode("span", { class: "top-title" }, "الأسئلة الشائعة"),
            _createElementVNode("h2", { class: "text-white" }, "كل ما تريد معرفته")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accordionItems, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["accordion-item", { active: _ctx.activeIndex === index }]),
                key: index
              }, [
                _createElementVNode("h2", _hoisted_6, [
                  _createElementVNode("button", {
                    class: "accordion-button",
                    type: "button",
                    "aria-expanded": _ctx.activeIndex === index ? 'true' : 'false',
                    onClick: ($event: any) => (_ctx.toggleAccordion(index))
                  }, _toDisplayString(item.question), 9, _hoisted_7)
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, _toDisplayString(item.answer), 1)
                  ])
                ], 512), [
                  [_vShow, _ctx.activeIndex === index]
                ])
              ], 2))
            }), 128))
          ])
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", {
          class: "col-lg-6",
          "data-aos": "fade-up",
          "data-aos-duration": "1000",
          "data-aos-delay": "200"
        }, [
          _createElementVNode("div", { class: "faq-img" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "faq"
            })
          ])
        ], -1))
      ])
    ])
  ]))
}